import React, { useCallback, useMemo, useRef } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { RawEditorSettings } from 'tinymce';
import Input from '../../forms/Input';
import Button from '../../forms/Buttom';

import { ContentPage } from './styles';
import { IEditResource, IPages } from '.';
import { useToast } from '../../../hooks/toast';
import { escapeHtml } from '../../../utils/escapeHtml';
import { normalizeVideoEmbedUrl } from '../../../utils/embedUrl';

interface IProps {
  handlePage(page: IPages): void;
  propsEditor: RawEditorSettings;
  setIsOpen: () => void;
  editResource: IEditResource;
}

const FormVideoAula: React.FC<IProps> = ({
  handlePage,
  propsEditor,
  setIsOpen,
  editResource,
}) => {
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);

  const isEdit = useMemo(() => {
    return Object.keys(editResource).length > 0;
  }, [editResource]);

  const handleSubmit = useCallback(
    async data => {
      const title = data.title?.trim();
      if (!title || !data.link?.trim()) {
        addToast({
          title: 'Ops ...',
          description: 'Informe o título e o link da videoaula',
          type: 'error',
        });
        return;
      }

      const linkSrc = normalizeVideoEmbedUrl(data.link);
      if (!linkSrc) {
        addToast({
          title: 'Ops ...',
          description: 'Informe um link de vídeo válido',
          type: 'error',
        });
        return;
      }

      if (isEdit) {
        editResource.element.setAttribute('data-resource', linkSrc);
        editResource.element.textContent = title;
        propsEditor.insertContent(propsEditor.selection.getContent());
      } else {
        propsEditor.insertContent(
          `<div class="resource" data-interaction="true" data-type="media" data-subtype="videoaula" data-resource="${escapeHtml(
            linkSrc,
          )}">
                ${escapeHtml(title)}
              </div>\n
              <p>&nbsp;</p>`,
        );
      }
      propsEditor.focus();
      setIsOpen();
    },
    [propsEditor, setIsOpen, isEdit, editResource.element, addToast],
  );
  return (
    <Form
      ref={formRef}
      onSubmit={handleSubmit}
      initialData={{
        title: editResource.element?.textContent?.trim(),
        link: editResource.resource,
      }}
    >
      <ContentPage>
        {!isEdit && (
          <button type="button" onClick={() => handlePage('main')}>
            Voltar
          </button>
        )}
        <div>
          <h2>Vídeoaula</h2>
          <Input
            label="Título da videoaula"
            name="title"
            type="text"
            placeholder="Ex.: Introdução à fisiologia"
          />
          <Input
            label="Inserir uma videoaula"
            name="link"
            type="text"
            placeholder='https://youtube.com.br/video ou <iframe src="https://youtube.com.br/video" />'
          />
          <Input hidden label="" name="type" defaultValue="videoaula" />
          <Button label="Inserir" type="submit" />
        </div>
      </ContentPage>
    </Form>
  );
};

export default FormVideoAula;
